export const obterCorLinha = (chave) => {
  if (!chave) return '#ffffff';
  if (chave.bloqueada || chave.status === 'B') return '#ffd6d6';
  if (chave.status === 'A') return '#dcf5dc';
  if (chave.em_analise || chave.status === 'N') return '#fff4c2';
  if (chave.todos_titulos_baixados || chave.bx === 'S') return '#f8f9fa';
  if (chave.tem_baixado_aberto) return '#d7e8ee';
  if (chave.status === 'D' || chave.status === 'X') return '#ffe1bd';
  return '#ffffff';
};
